import { Directive, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgControl } from '@angular/forms';
declare var $;
@Directive({
  selector: '[appSelect2]'
})
export class Select2Directive {
    public select2;
    @Output() selected: EventEmitter<string>;
    constructor(el: ElementRef, private control:NgControl) {
        console.log(el.nativeElement);
        this.selected = new EventEmitter();
        this.select2 = $(el.nativeElement).select2({
            width: '100px'
        });
        this.select2.on('select2:select',(event)=>{
            this.control.control.setValue(event.params.data.id);
            this.selected.next();
        });
        this.select2.on("select2:open",()=>{
            this.control.control.markAsTouched();
        });
    }
}
